function printerSetFont(a,b,c,d,e) {
	window.Android.pSetFont(a,b,c,d,e)
}


export function hasAndroidBridge() {
  return typeof window !== 'undefined'
    && window.Android
    && typeof window.Android.dIsDeviceConnected === 'function';
}

export function isTrue(v) {
  return v === true || v === 'true' || v === 1 || v === '1';
}

/**
 * 安全检查打印机连接（浏览器/PC 环境不报错，直接提示未连接）
 * @param {Vue} ctx this（为了用 ctx.$message）
 * @returns {boolean} 是否已连接
 */
export function checkPrinterConnected(ctx) {
  try {
    if (!hasAndroidBridge()) {
      ctx && ctx.$message && ctx.$message.error('打印机未连接');
      return false;
    }
    const res = window.Android.dIsDeviceConnected();
    const ok = isTrue(res);
    if (!ok) ctx.$message && ctx.$message.error('打印机未连接');
    return !!ok;
  } catch (e) {
    console.error('调用 Android.dIsDeviceConnected 异常：', e);
    ctx && ctx.$message && ctx.$message.error('打印机未连接');
    return false;
  }
}


export function checkPrinterConnectedNoMessage(ctx) {

 try {
     if (!hasAndroidBridge()) {
       return false;
     }
     const res = window.Android.dIsDeviceConnected();
     return !!isTrue(res);
   } catch (e) {
     console.error('调用 Android.dIsDeviceConnected 异常：', e);
     return false;
   }
}



// WEBPACK FOOTER //
// ./src/api/printer.js